import { TmdxAvatar } from '@ds';
import { ConditionalRender } from '@ui';
import { getFileUrl } from '@/api/utils';

export const FacilityRow = ({ name, logo }: { name?: string; logo?: string }) => {
  return (
    <ConditionalRender show={!!name} placeholder="-">
      <div className="flex gap-2 items-center">
        <TmdxAvatar radius="xl" size="md" type="facility" src={getFileUrl(logo)} />
        <div className="flex-1 truncate min-w-0">{name}</div>
      </div>
    </ConditionalRender>
  );
};
